import { formatMoney } from "./formatMoney";

export type DiscountType = "percentage" | "fixed_amount";

/**
 * Render a per-seat discount as the same human-readable string everywhere it
 * surfaces in the checkout UI. Percentage discounts show "10% off per seat";
 * fixed-amount discounts show "$12.50 off per seat".
 */
export function formatDiscountDisplayText(
  type: DiscountType,
  value: number,
): string {
  return type === "percentage"
    ? `${value}% off per seat`
    : `$${formatMoney(value)} off per seat`;
}
